export const ARTICLE_V3 = "article-v3" // Active
export const QUIZ = "quiz" // Active
export const TOPICS_V2 = "topics-v2" // Active
export const WEBFLOW = "webflow" // Active
export const WEBFLOW_LANDING_PAGE = "webflow-landing-page" // Active
export const HUBSPOT_CHAT_WIDGET = "hubspot" // Active
export const B2C_SUNSET = "b2c-sunset" // Active
export const LICENCE_ACTIVATION_FORM_V2 = "licence-activation-form-v2"
export const PLATFORMISATION = "platformisation"
export const USE_V2_TAG_CLASSIFICATION = "use_v2_tag_classification"
export const NAVBAR_DEALS_CLASS_NAME = "navbar_deals_class_name"
export const SIDEBAR_COUNTRIES_CLASS_NAME = "sidebar_countries_class_name"
export const SIDEBAR_INDUSTRIES_CLASS_NAME = "sidebar_industries_class_name"
export const EXTRA_SIDEBAR_ITEMS = "extra_sidebar_items"
export const EXTRA_SIDEBAR_TOP_ITEMS = "extra_sidebar_top_items"
export const SIDEBAR_MAX_DEPTH = "sidebar_max_depth"
export const FILTER_COUNTRIES_CLASS_NAME = "filter_countries_class_name"
export const FILTER_INDUSTRIES_CLASS_NAME = "filter_industries_class_name"
export const SHOW_EXTRA_FIELD_EBITDA = "show_extra_field_ebitda"
export const SHOW_EXTRA_FIELD_REVENUE = "show_extra_field_revenue"
export const ENABLE_COMPANY_PROFILE = "enable_company_profile"
export const ENABLE_COMPANY_FINANCIALS = "enable_company_financials"
export const FINANCIALS_MULTIPLES_MAPPING =
  "financials_multiples_metrics_mapping"
export const FINANCIALS_INCOME_MAPPING = "financials_income_metrics_mapping"
export const FINANCIAL_INSTITUTION_BANK = "financial_institutions_banks"
export const FINANCIAL_INSTITUTION_NON_BANK = "financial_institutions_non_banks"

export const FINANCIALS_BALANCE_SHEET_MAPPING =
  "financials_balance_sheet_mapping"
export const FINANCIALS_CASH_FLOW_MAPPING = "financials_cash_flow_mapping"
export const AVAILABLE_COUNTRY_RISK_SLUGS = "available_country_risk_slugs"
export const ENABLE_COMPANY_TRANSACTIONS = "enable_company_transactions"
export const SHOW_EXTRA_COMPANY_SCREENER_COMPUTED_FIELDS =
  "show_extra_company_screener_computed_fields"
export const ENABLE_COMPANY_SCREENER_INVESTOR_FIELD =
  "enable_company_screener_investor_field"
export const ENABLE_EXTRA_FINANCIAL_FIELDS = "enable_extra_financial_fields"
export const ENABLE_LAST_PRE_MONEY_VALUATION_COLUMN =
  "enable_last_pre_money_valuation_column"
export const ENABLE_LAST_POST_MONEY_VALUTION_COLUMN =
  "enable_last_post_money_valuation_column"
export const UNCHECKED_TRANSACTION_LIST_COLUMNS_DEFAULT =
  "unchecked_transaction_list_columns_default"

export const ENABLE_TRANSACTION_COMPS = "enable_transaction_comps"
export const SHOW_TRANSACTION_ID = "show_transaction_id"

export const ENABLE_SEARCH_V2 = "enable_search_v2"

export const ENABLE_CLEAR_ALL_SEARCHES = "enable_clear_all_searches"

export const SHOW_VIEW_ALL_SEARCH_RESULTS = "show_view_all_search_results"

export const DEFAULT_HOME_PAGE = "default_home_page"

export const ENABLE_COMPANY_OVERVIEW_V2 = "enable_company_overview_v2"
export const ENABLE_COMPANY_OVERVIEW_V3 = "enable_company_overview_v3"

export const ENABLE_TRANSACTIONS_PROFILE_V2 = "enable_transactions_profile_v2"
export const ENABLE_TRANSACTIONS_PROFILE_MULTIPLES =
  "enable_transaction_profile_multiples"

export const ENABLE_VALUATION_BENCHMARKS = "enable_valuation_benchmarks"

export const IS_WEBFLOW_COUNTRY_RISK_PATH = "is_webflow_country_risk_path"

export const ENABLE_LIMITED_PARTNERS_TRANSACTIONS =
  "enable_limited_partners_transactions"

export const CLEAR_RECENTLY_VISITED_PAGE = "clear_recently_visited_pages"

export const ENABLE_COMPANY_FINANCIALS_DOWNLOADS =
  "enable_company_financials_downloads"

export const ENABLE_LIMITED_COMPANY_PROFILE_MENU = "enable_company_profile_menu"

export const ENABLE_LP_COMMITMENT_METRICS_FIELDS =
  "enable_lp_commitment_metrics_fields"

export const ENABLE_INVESTMENT_FUND_MANAGER = "enable_investment_fund_manager"

export const ENABLE_FUND_FINANCING_TYPE = "enable_fund_financing_type"

export const ENABLE_LIMITED_PARTNER_PROFILE = "enable_limited_partner_profile"
export const ENABLE_COMMITMENTS_COLUMN = "enable_commitments_column"
export const ENABLE_COMMITMENT_DATE = "enable_commitment_date"
export const ENABLE_AMOUNT_COMMITTED = "enable_amount_committed"
export const ENABLE_TOTAL_FUNDS_COMMITTED = "enable_total_funds_committed"
export const ENABLE_TRANSACTIONS_AGGREGATE_METRICS =
  "enable_transactions_aggregate_metrics"

export const ENABLE_SHOW_MULTIPLES = "enable_show_multiples"
export const ENABLE_SEMANTIC_SEARCH = "enable_semantic_search"
export const ENABLE_AI_SEARCH = "enable-ai-search"

export const MIXPANEL_SESSION_RECORDING_PERCENTAGE =
  "mixpanel_session_recording_percentage"

export const ENABLE_COLUMN_COMPANY_STATUS = "enable_column_company_status"

export const ENABLE_STEARS_PRO = "enable_stears_pro"

export const featureFlags = {
  ARTICLE_V3,
  QUIZ,
  TOPICS_V2,
  WEBFLOW,
  WEBFLOW_LANDING_PAGE,
  HUBSPOT_CHAT_WIDGET,
  B2C_SUNSET,
  LICENCE_ACTIVATION_FORM_V2,
  PLATFORMISATION,
  USE_V2_TAG_CLASSIFICATION,
  SIDEBAR_COUNTRIES_CLASS_NAME,
  SIDEBAR_INDUSTRIES_CLASS_NAME
  // DEFAULT_HOME_PAGE
}

export type FeatureFlag = (typeof featureFlags)[keyof typeof featureFlags]
